import isNil from 'lodash/isNil'
import React, { FC } from 'react'
import styled from 'styled-components'

import AngleRightIcon from '@Assets/SVG/AngleRight'
import { SVGIcon } from '@Components/Icons'
import { Link } from '@Components/Link'
import { NavigationEvent } from '@Events/Navigation'

const StyledItem = styled(Link)`
  position: relative;
  display: flex;
  align-items: center;
  min-height: 60px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyLighter};
`

const StyledItemTitle = styled.span`
  display: flex;
  align-items: center;
  flex-grow: 2;
  padding: 10px 0 10px 20px;
  line-height: 1.3;
`

const StyledItemCount = styled.span`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.grey};
  padding-left: 6px;
`

const StyledArrowWrap = styled.div`
  margin-right: 20px;
`

interface SubCategoryItemProps {
  categoryID: string
  count?: number
  title: string
  url: string
}

export const SubCategoryItem: FC<SubCategoryItemProps> = (
  {
    categoryID,
    count,
    title,
    url,
  }: SubCategoryItemProps,
) => (
  <StyledItem
    event={new NavigationEvent({
      attributes: {
        dest_page_type: 'category',
        dest_page_type_id: categoryID,
        source_id: 'mobile_menu',
      },
      eventName: 'nav_link_click',
    })}
    href={url}
  >
    <StyledItemTitle>
      {title}
      {!isNil(count) && (
        <StyledItemCount>
          (
          {count}
          )
        </StyledItemCount>
      )}
    </StyledItemTitle>

    {/* Arrow */}
    <StyledArrowWrap>
      <SVGIcon icon={AngleRightIcon} size="14px" />
    </StyledArrowWrap>
  </StyledItem>
)
